import { get } from 'lodash';
import { request, RequestInitWithRetry } from '../../lib/request';
import { ISortResult } from '../shared/common';

export interface IDeviceAnomalyData {
  id: string,
  serialNumber: string,
  assetTag: string,
  imei: string,
  deviceName: string,
  platformType: string,
  manufacturer: string,
  model: string,
  group: string[],
  homeLocation: { name: string } | null,
  totalCount: number,
  score: number,
  deviceRebooted: number,
  deviceLowPower: number,
  deviceDropped: number,
  totalDataUsage: number,
  processCrashed: number,
  processHung: number,
  lastOccurred: number
}

export interface IDeviceAnomaliesListData {
  list: IDeviceAnomalyData[],
  totalCount: number,
  platforms: string[]
}

export interface IDeviceAnomaliesListFilter {
  manufacturers?: string[],
  models?: string[],
  groups?: Array<string | null>,
  homeLocations?: string[],
  platforms?: string[],
  manufacturers_negate?: boolean,
  models_negate?: boolean,
  groups_negate?: boolean,
  homeLocations_negate?: boolean,
  anomalyType?: string | null
}

export interface IDeviceAnomaliesListOptions {
  limit: number,
  offset: number,
  search?: string,
  sort?: ISortResult,
  filter?: IDeviceAnomaliesListFilter,
  timeZone?: string
}

const getFilterParams = (filter: IDeviceAnomaliesListFilter = {}) => {
  return {
    manufacturers: filter.manufacturers || [],
    models: filter.models || [],
    groups: filter.groups || [],
    homeLocations: filter.homeLocations || [],
    platforms: filter.platforms || [],
    ...(filter.manufacturers_negate && { manufacturers_negate: true }),
    ...(filter.models_negate && { models_negate: true }),
    ...(filter.groups_negate && { groups_negate: true }),
    ...(filter.homeLocations_negate && { homeLocations_negate: true }),
    ...(filter.anomalyType && { anomalyType: filter.anomalyType })
  };
};

export function getDeviceAnomaliesList(params: IDeviceAnomaliesListOptions) {
  return async (options: RequestInitWithRetry): Promise<IDeviceAnomaliesListData> => {
    const input = {
      path: `/api/core/anomalies-beta/devices/list`,
      qs: { limit: params.limit, offset: params.offset },
      body: {
        sort: get(params, 'sort'),
        search: get(params, 'search'),
        ...getFilterParams(params.filter)
      }
    };
    return request(input, options);
  };
}

export function exportDeviceAnomaliesListAction(requestOptions: RequestInitWithRetry) {
  return async (options: IDeviceAnomaliesListOptions): Promise<string> => {
    const input = {
      path: `/api/core/anomalies-beta/devices/export`,
      qs: { limit: options.limit, offset: options.offset },
      body: {
        sort: get(options, 'sort'),
        search: get(options, 'search'),
        timeZone: get(options, 'timeZone'),
        ...getFilterParams(options.filter)
      },
      method: 'post'
    };
    return request(input, requestOptions);
  };
}
